// src/utils/formatDate.js

// Treat empty values and unset backend dates (.NET DateTime.MinValue -> "0001-01-01")
// as no date, so the UI shows a dash instead of "1/1/1".
const isUnsetDate = (dateString) => {
  if (!dateString) return true
  const d = new Date(dateString)
  if (isNaN(d.getTime())) return true
  if (d.getFullYear() < 1970) return true
  return false
}

export const formatDateTime = (dateString) => {
  if (isUnsetDate(dateString)) return '-'
  return new Date(dateString).toLocaleString('en-US', {
    year: 'numeric',
    month: 'numeric',
    day: 'numeric',
    hour: 'numeric',
    minute: '2-digit',
    hour12: true,
  })
}

export const formatDateOnly = (dateString) => {
  if (isUnsetDate(dateString)) return '-'
  return new Date(dateString).toLocaleString('en-US', {
    year: 'numeric',
    month: 'numeric',
    day: 'numeric',
  })
}
